"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _commonCta = require("@mmc/common-cta");

var _filterColumn = _interopRequireDefault(require("./filter-column"));

var _modelFilter = _interopRequireDefault(require("../styles/model-filter.css"));

var _modelFilter2 = _interopRequireDefault(require("./model-filter.props/model-filter.defaultProps"));

var _modelFilter3 = _interopRequireDefault(require("./model-filter.props/model-filter.propTypes"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps,
    handleNestedProp = dataUtils.handleNestedProp,
    isEmptyArray = dataUtils.isEmptyArray;
var typeMap = {
  /* eslint-disable */
  drive_train: 'drivetrain',
  fuel_type: 'fuelType',
  transmission_type: 'transmissionType'
  /* eslint-enable */

};

var ModelFilter = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(ModelFilter, _React$Component);

  function ModelFilter() {
    return _React$Component.apply(this, arguments) || this;
  }

  ModelFilter.resourceType = function resourceType() {
    return 'ModelFilter_1_0_0';
  };

  var _proto = ModelFilter.prototype;

  _proto.renderColumns = function renderColumns(theme, dataObj) {
    var changeEvent = this.props.changeEvent || null;
    var selectedOptions = this.props.selectedOptions || [];
    var enabledOptions = this.props.enabledOptions || {};
    var enabledOptionsArray = dataObj.filters.map(function (filter) {
      var enabledOptionArray = [];
      var filterKey = '';

      if (filter.filteringOptions && !isEmptyArray(filter.filteringOptions)) {
        filterKey = typeMap[filter.filteringOptions[0].type];
        enabledOptionArray = enabledOptions[filterKey].slice();
      }

      return {
        options: enabledOptionArray,
        key: filterKey
      };
    });
    return dataObj.filters && dataObj.filters.map(function (el, i) {
      if (selectedOptions[i] === undefined) {
        return /*#__PURE__*/_react["default"].createElement(_filterColumn["default"], {
          key: i,
          data: el,
          theme: theme,
          index: i,
          changeEvent: changeEvent,
          optionKey: enabledOptionsArray[i].key,
          enabledOptions: enabledOptionsArray[i].options
        });
      }

      return /*#__PURE__*/_react["default"].createElement(_filterColumn["default"], {
        key: i,
        data: el,
        theme: theme,
        index: i,
        changeEvent: changeEvent,
        selectedOption: selectedOptions[i],
        optionKey: enabledOptionsArray[i].key,
        enabledOptions: enabledOptionsArray[i].options
      });
    });
  };

  _proto.renderInfo = function renderInfo(title, text, theme) {
    if (title || text) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _modelFilter["default"].infoWrapper
      }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: theme.inputsAndOptions
      }, title, " "), /*#__PURE__*/_react["default"].createElement("span", {
        className: theme.bodyCopy + " " + _modelFilter["default"].infoText
      }, text)));
    }

    return null;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        data = _this$props.data,
        theme = _this$props.theme,
        defaultData = _this$props.defaultData,
        headingText = _this$props.headingText;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    var selectedOptions = this.props.selectedOptions || [];
    var firstWordRegex = new RegExp('[A-Za-z0-9:-;]+');
    var selectionText = {
      text: handleNestedProp(componentData, 'componentData.label.text')
    };
    var resetLabel = componentData.resetLabel || '';
    var resetBtn = {
      label: resetLabel,
      priority: 'low'
    };
    var clearAll = this.props.clearAll || null;
    var hasSelection = false;
    selectionText.intro = firstWordRegex.exec(selectionText.text);
    selectionText.text = selectionText.text.replace(firstWordRegex, '');

    if (selectedOptions.length > 0) {
      if (selectedOptions.find(function (option) {
        return option !== '';
      })) {
        hasSelection = true;
      }
    }

    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid'] + " " + _modelFilter["default"].container
    }, /*#__PURE__*/_react["default"].createElement("h2", {
      className: theme.headingThree + " " + theme.marginBottom40 + " " + _modelFilter["default"].headLine
    }, handleNestedProp(headingText, 'headingText.title')), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row
    }, this.renderColumns(theme, componentData)), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row + " " + (hasSelection && resetLabel !== '' ? _modelFilter["default"].isExpanded : '') + " " + _modelFilter["default"].resetPanel
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + _modelFilter["default"].bottomLinksWrapper
    }, this.renderInfo(handleNestedProp(componentData, 'componentData.notes.title'), handleNestedProp(componentData, 'componentData.notes.text'), theme), /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      data: resetBtn,
      classes: [_modelFilter["default"].resetBtn],
      theme: theme,
      clickEvent: clearAll
    })))));
  };

  return ModelFilter;
}(_react["default"].Component);

exports["default"] = ModelFilter;
ModelFilter.displayName = 'ModelFilter';
ModelFilter.defaultProps = {
  data: _modelFilter2["default"],
  defaultData: _modelFilter2["default"],
  theme: {}
};